export { type IWordTiming, wordTimingSchema } from './word-timing-schema';
